import { render, staticRenderFns } from "./AccountFormBusiness.vue?vue&type=template&id=1b70f375&scoped=true&"
import script from "./AccountFormBusiness.vue?vue&type=script&lang=ts&"
export * from "./AccountFormBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./AccountFormBusiness.vue?vue&type=style&index=0&id=1b70f375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70f375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
